import {type LocaleEnum} from '../types/locale';
import {validateLocale} from './validateLocale';

export const localeToOpenGraphLocale = (locale: LocaleEnum) => {
  validateLocale(locale);
  return locale.replace('-', '_');
};
